<template>
  <div class="form-daftar">
    <va-form ref="form" type="vertical" class="th-form">
      <div class="flex flex-col md:flex-row gap-4">
        <va-form-item class="w-full md:w-1/2" label="Nama Depan" need>
          <va-input
            name="Nama Depan"
            v-model="register.firstName"
            :rules="[{ type: 'required' }]"
          />
        </va-form-item>
        <va-form-item class="w-full md:w-1/2" label="Nama Belakang" need>
          <va-input
            name="Nama Belakang"
            v-model="register.lastName"
            :rules="[{ type: 'required' }]"
          />
        </va-form-item>
      </div>
      <va-form-item label="Email" need>
        <va-input
          :disabled="Boolean(googleIdToken || fbIdToken)"
          name="Email"
          v-model="register.email"
          :rules="[{ type: 'required' }]"
        />
      </va-form-item>
      <va-form-item label="Kata Sandi" need>
        <va-input
          name="Kata Sandi"
          type="password"
          v-model="register.password"
          :rules="[{ type: 'required' }]"
        />
      </va-form-item>
      <va-form-item
        label="Konfirmasi Kata Sandi"
        need
        style="margin-bottom: 30px"
      >
        <va-input
          name="Konfirmasi Kata Sandi"
          type="password"
          v-model="register.retypePassword"
          :rules="[{ type: 'required' }]"
        />
      </va-form-item>
      <button
        type="submit"
        @click.prevent="registerAccount"
        class="va-btn va-btn-block va-btn-md va-btn-primary"
      >
        <div>Daftar</div>
      </button>
      <div style="margin-top: 30px" class="text-center">
        <small
          >Sudah Punya Akun?
          <span
            class="th-link small th-hover-pointer"
            @click.prevent="goTo('Masuk')"
            >Masuk</span
          ></small
        >
      </div>
    </va-form>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      register: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        retypePassword: '',
      },
      googleIdToken: null,
      fbIdToken: null,
    }
  },
  methods: {
    registerAccount() {
      this.$refs.form.validateFields(async (result) => {
        try {
          if (result.isvalid) {
            const data = {
              firstName: this.register.firstName,
              lastName: this.register.lastName,
              password: this.register.password,
              email: this.register.email,
              confirmPassword: this.register.retypePassword,
            }
            if (this.googleIdToken) data.googleIdToken = this.googleIdToken
            if (this.fbIdToken) data.fbIdToken = this.fbIdToken
            // console.log('masuk')
            await this.$store.dispatch('user/REGISTER_ACCOUNT', { registerData: data })
            this.notification.success({
              title: 'Berhasil Mendaftarkan Akun Baru',
              message: 'Silahkan login kembali untuk masuk',
              duration: 5000,
            })
            // console.log(newData)
            this.goTo('Masuk')
          } else {
            this.notification.danger({
              title: 'Terdapat Data yang Belum Valid/Terisi',
              duration: 5000,
            })
          }
        } catch (err) {
          console.log(err)
          // this.notification.danger({
          //   title: 'Terdapat Data yang Belum Terisi',
          //   duration: 5000,
          // })
        }
      })
    },
    goTo(routeName) {
      if (routeName === this.$route.name) return
      this.$router.push({ name: routeName })
    },
    async checkFb(accessToken, email) {
      try {
        let isValid = false
        const { data } = await axios.get('https://graph.facebook.com/me', {
          params: {
            fields: 'name,email,first_name,middle_name,last_name',
            access_token: accessToken,
          },
        })
        if (data.email === email) isValid = true
        const user = {
          email: data.email,
          firstName: this.getFirstName(data.first_name, data.middle_name),
          lastName: data.last_name,
        }
        return new Promise((resolve, reject) => {
          resolve({ isValid, user })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    getFirstName(firstName, middleName) {
      if (!middleName) return firstName
      else if (!firstName) return middleName
      return firstName + ' ' + middleName
    },
  },
  async created() {
    try {
      if (this.$route.query) {
        const { googleIdToken, fbIdToken, email } = this.$route.query
        if (fbIdToken) {
          const { isValid, data } = await this.checkFb(fbIdToken, email)
          if (isValid) {
            this.fbIdToken = fbIdToken
            this.register = {
              ...this.register,
              ...data,
            }
          } else {
            this.notification.danger({
              title: 'Maaf, token tidak valid.',
              duration: 3000,
            })
            this.$router.push({ name: 'Daftar' })
          }
        } else if (googleIdToken) {
          const data = await this.$store.dispatch('user/GOOGLE_VALIDATION', { googleIdToken })
          if (data.email === email) this.register.email = email
          this.register.firstName = data.firstName
          this.register.lastName = data.lastName
          this.googleIdToken = googleIdToken
        }
      }
    } catch (err) {
      return new Promise((resolve, reject) => {
        reject(err)
      })
    }
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";
.form-daftar {
  .width-half-form {
    width: 50% !important;
    float: left;
  }

  .va-err-tip {
    display: none;
  }
}
</style>
